<template>
    <div>
        <div class="col-12 pt-1">
            <div class="prod__colors">
                <div class="title">Цвет: </div>
                <div @click="changeVariant" v-for="(color, key) in this.colorsLocal" :class="[variantIdLocal==key ? 'item--active' : '', 'item']" :data-variant_id="key" :style="{background : '#' + color.background}">
                    <img :src="color.src" class="round" />
                </div>
            </div>
        </div>
        <div v-if="show_buttonLocal" class="col-12 mb-2">
            <a v-html="buttonTxt" v-if="this.cart_qty==0"
                    href="#"
                    @click="addItem"
                    :class="css_classLocal"
                    :title="titleLocal"
                    data-initial-text="Купить"><slot></slot>
            </a>
                <a v-else
                    href="/cart"
                   class="btn btn--white card4__btn p-buy__buy-btn"
                   >
                    В корзине
                </a>
        </div>
    </div>
</template>

<script>
    export default {
        name: "cart-add-button-product-variant",
        props: {
            product_id : Number,
            variant_id: Number,
            price : String,
            title : String,
            css_class: {
                type : String,
                default: 'btn btn--red p-buy__buy-btn'
            },
            base_url : String,
            show_button: Number,
            colors: Object
        },
        data () {
            return {
                productIdLocal: this.product_id,
                variantIdLocal: this.variant_id,
                priceLocal: this.price,
                titleLocal: this.title,
                css_classLocal: this.css_class,
                base_urlLocal: this.base_url,
                loading: false,
                show_buttonLocal: this.show_button,
                colorsLocal: this.colors
            }
        },
        computed: {
            cart_qty () {
                const cart_items = this.$store.getters.cartitems;
                let product = cart_items.filter((item) => {
                    console.log(item)
                    console.log(this.productIdLocal)
                    console.log(this.variantIdLocal)
                    return (item.product_id==this.productIdLocal && item.variant_id==this.variantIdLocal);
                });
                console.log(product)
                if(typeof product[0] !== 'undefined') {
                    return product[0].qty;
                }
                return 0;
            },
            buttonTxt() {
                if(this.$store.getters.loading && this.loading) {
                    return '<i class="fa fa-spinner fa-spin fa-1x fa-fw"></i>';
                } else {
                    return '<img src="' + this.base_urlLocal + '/img/cart.png" alt=""><span>Добавить в корзину</span>';
                }
            },
        },
        methods: {
            addItem(event) {
                this.loading = true;
                event.preventDefault();
                this.$store.dispatch(
                    'addProduct',
                    {
                        product_id: this.productIdLocal,
                        qty: 1,
                        variant_id: this.variantIdLocal
                    })
            },
            changeVariant(event) {
                this.variantIdLocal=event.target.dataset.variant_id;
                this.gallerySelect()
            },
            gallerySelect() {
                var itm = $('.slick-slide .item[data-variant_id="' + this.variantIdLocal +'"]');
                var idx = itm.closest('.slick-slide').data('slick-index');

                if(typeof(idx) !== 'undefined') {
                    $('.js-p-gal-nav').slick('slickGoTo', idx);

                }
            }
        }
    }
</script>

<style scoped>

</style>